import { Reveal, Eyebrow } from "../components/Reveal";
import { CONTACT } from "../data/experiences";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you send an inquiry or chat with our concierge, we collect your name, email address and the journey details you choose to share, such as dates, group size and interests. We do not collect payment details on this website.",
  },
  {
    title: "How we use it",
    body: "Your information is used only to design, quote and deliver your journey, and to reply to your messages. It is shared solely with the guides, hotels and transport partners required to operate your trip, and only to the extent needed.",
  },
  {
    title: "What we never do",
    body: "We never sell your data, never share it with advertisers and never send marketing email you did not ask for.",
  },
  {
    title: "Storage and retention",
    body: "Inquiry records are stored securely and kept only while they are needed to plan your travel or meet legal obligations. Chat conversations with the concierge are stored so the team can follow up on what you discussed.",
  },
  {
    title: "Your rights",
    body: `You may ask us at any time to show, correct or delete the information we hold about you. Write to ${CONTACT.email} and we will respond within 7 days.`,
  },
];

export default function Privacy() {
  return (
    <main data-testid="privacy-page" className="bg-ivory">
      <section className="pt-40 pb-16 bg-obsidian text-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-accent text-xs tracking-[0.4em] text-gold mb-6">LEGAL</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl" data-testid="privacy-headline">Privacy Policy.</h1>
        </div>
      </section>
      <section className="py-20 sm:py-28">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-14">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title}>
              <section data-testid={`privacy-section-${i}`}>
                <Eyebrow>{String(i + 1).padStart(2, "0")}</Eyebrow>
                <h2 className="mt-3 font-serif text-3xl text-maroon mb-4">{s.title}</h2>
                <p className="text-[#5C4F52] text-base leading-relaxed">{s.body}</p>
              </section>
            </Reveal>
          ))}
          <Reveal>
            <p className="text-sm text-[#5C4F52]/70 border-t border-gold/25 pt-8">
              Questions about this policy? Write to {CONTACT.email}. {CONTACT.company}, New Delhi, India.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
